import styled from 'styled-components';

export const StyledSubMenu = styled.div``;
